<script setup lang="ts">
import './assets/style.scss'
import { useInventoryLEPModal } from './../model/model.ts'
import { VModal } from '@/shared/ui'

const model = useInventoryLEPModal()
</script>

<template>
  <VModal v-model="model.open" :title="$t('itf.merge_into_lep')">
    <p class="text_small">{{ $t('itf.merge_into_lep_info') }}</p>
  </VModal>
</template>
